import { defineComponent as _defineComponent } from 'vue'
import useRouter from "@/router/useRouter"
import Footer from "@/components/layout/Footer.vue"
import { THEMES } from "@/constants"


export default /*#__PURE__*/_defineComponent({
  __name: 'UnAuthPage',
  setup(__props) {

const { router, routes } = useRouter()

const routeHome = () => {
  router.push({ name: routes.Home })
}

return { __sfc: true,router, routes, routeHome, Footer, THEMES }
}

})